// ------------------------------------
// Loader
// ------------------------------------

// Variáveis
const $loader = $('#loader');
const $loaderText = $('#loader-text');
const loaderDefaultText = 'Por favor, aguarde...';

// Exibe o loader
function showLoader(text = loaderDefaultText) {
  $loaderText.text(text);
  $loader.addClass('active');
}

// Oculta o loader
function hideLoader() {
  $loader.removeClass('active');
}
